<template>
  <h2>What is rpgRoot?</h2>
  <p>
    It is Multiplayer Role Play Games center. It allows to create RPG session,
    aggregate all games and players. It handle technical details for you.
  </p>
  <h2>WHY rpgRoot?</h2>
  <ul>
    <li>
      - tech should not be the limit for game design - it sould be the tool for
      a <b>creative minds</b>
    </li>
    <li>
      - unlish your creativity and provide the best experience for the players
    </li>
    <li>
      - create a single world, then tweak and test your design ideas in it
    </li>
    <li>- no more techy configurations of forum / chat / game server</li>
    <li>- choose which elements suffice your game and players needs</li>
  </ul>
  <h2>Do you know this story?</h2>
  <p>
    You play a game and you think:
    <br />
    <br />
    <i
      >- I would change a few details here... Like the battle stats or character
      names.</i
    >
    <br />
    Before rpgRoot: you had to create a game from scratch to do that.
    <br />
    It took a lot of time and effort. And you had to know how to code.
    <br />
    <br />
    <i>- Now, it's not!</i>
    With rpgRoot you can create your own game based on existing ones.
    <br />
    Without any technical knowledge. You don't need to know any programming
    language or how to set up servers.
    <br />
    Just focus on what is the most important - the game design and players.
  </p>
  <p>Modern game engines allow creating any game! From scratch...</p>
  <p>
    We decide to specialize in so glorious RPG games. And theirs most
    fascinating elements:
  </p>
  <ul>
    <li>- the plot</li>
    <li>- multiplayer</li>
  </ul>
  <p>
    Create your own Text Based Browser Game (<b>#TBBG</b>) RPG game and join the
    community of indiedevs.
  </p>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {}
})
export default class Index extends Vue {}
</script>

<style scoped>
ul {
  list-style: none;
}
</style>
